export const getPositionStyles = (position) => {
  switch (position) {
    case 'top left':
      return (
        `top: -10px;
        left: -18px;
        transform: translateY(-100%);
        `
      );
    case 'top center':
      return (
        `top: -10px;
        left: 50%;
        transform: translate(-50%, -100%);
        `
      );
    case 'top right':
      return (
        `top: -10px;
        right: -18px;
        transform: translateY(-100%);
        `
      );
    case 'right top':
      return (
        `top: -18px;
        right: -18px;
        transform: translateX(100%);
        `
      );
    case 'right center':
      return (
        `top: 50%;
        right: -18px;
        transform: translate(100%, -50%);
        `
      );
    case 'right bottom':
      return (
        `bottom: -10px;
        right: -18px;
        transform: translateX(100%);
        `
      );
    case 'bottom left':
      return (
        `bottom: -10px;
        left: -18px;
        transform: translateY(100%);
        `
      );
    case 'bottom center':
      return (
        `bottom: -10px;
        left: 50%;
        transform: translate(-50%, 100%);
        `
      );
    case 'bottom right':
      return (
        `bottom: -10px;
        right: -18px;
        transform: translateY(100%);
        `
      );
    case 'left top':
      return (
        `top: -18px;
        left: -18px;
        transform: translateX(-100%);
        `
      );
    case 'left center':
      return (
        `top: 50%;
        left: -18px;
        transform: translate(-100%, -50%);
        `
      );
    case 'left bottom':
      return (
        `bottom: -10px;
        left: -18px;
        transform: translateX(-100%);
        `
      );
    default:
      return '';
  }
};

export const getArrowDownPositionStyles = (position) => {
  switch (position) {
    case 'right':
      return (
        'right: 20px;'
      );
    case 'left':
      return (
        'left: 20px;'
      );
    case 'center':
      return (
        `left: 50%;
          transform: translateX(-50%);`
      );
    default:
      return '';
  }
};

export const getArrowLeftPositionStyles = (position) => {
  switch (position) {
    case 'top':
      return (
        'top: 20px;'
      );
    case 'center':
      return (
        `top: 50%;
        transform: translateY(-50%);`
      );
    case 'bottom':
      return (
        'bottom: 15px;'
      );
    default:
      return '';
  }
};

export const getArrowTopPositionStyles = (position) => {
  switch (position) {
    case 'right':
      return (
        'right: 20px;'
      );
    case 'left':
      return (
        'left: 20px;'
      );
    case 'center':
      return (
        `left: 50%;
          transform: translateX(-50%);`
      );
    default:
      return '';
  }
};

export const getArrowRightPositionStyles = (position) => {
  switch (position) {
    case 'top':
      return (
        'top: 20px;'
      );
    case 'center':
      return (
        `top: 50%;
        transform: translateY(-50%);`
      );
    case 'bottom':
      return (
        'bottom: 15px;'
      );
    default:
      return '';
  }
};
